import script from "./reviewInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewInfo.vue?vue&type=script&setup=true&lang=js"

import "./reviewInfo.vue?vue&type=style&index=0&id=2a74b532&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a74b532"]])

export default __exports__